import { useState } from 'react'
import apiPost from 'lib/network/apiPost'
import Button from 'components/atoms/Button'
import Selection from 'components/molecules/Selection'
import trim from 'lodash/trim'

const LeadContactActionModal = ({ leadId, onSuccess, t, close }) => {
  const [type, setType] = useState('email')
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false)
  const contactTypeOptions = [{ id: 'email', name: t('crm.contact.email') }]

  const submit = async () => {
    // eslint-disable-next-line
    if (!trim(note)) return
    setLoading(true)
    const res = await apiPost(`crm/leads/${leadId}/contacts`, { type, note })
    setLoading(false)
    if (res?.success) {
      onSuccess?.()
      close?.()
    }
  }

  return (
    <div className="space-y-3">
      <Selection className="w-full" value={type} onChange={option => setType(option?.id || 'email')} list={contactTypeOptions} title={t('crm.contact.email')} />
      <textarea className="w-full border rounded-md px-3 py-2 min-h-[120px]" value={note} onChange={e => setNote(e.target.value)} placeholder={t('crm.labels.note')} />
      <div className="flex justify-end">
        <Button onClick={submit} disabled={loading}>
          {loading ? t('crm.actions.addContacting') : t('crm.actions.addContact')}
        </Button>
      </div>
    </div>
  )
}

export default LeadContactActionModal
